"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _table = require("./table");

var _ref = _react.default.createElement("div", {
  className: "table-header-selectionStub"
});

var TableHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TableHeader, _PureComponent);

  function TableHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TableHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TableHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderCell", function (column, key) {
      var props = {
        key: key,
        className: (0, _classnames.default)('table-header-cell', {
          'table-header-cell--fixed': column.fixed
        }),
        style: (0, _table.columnStyle)(column),
        children: column.name ? column.name() : null
      };
      return _react.default.createElement("div", props);
    });
    return _this;
  }

  (0, _createClass2.default)(TableHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          isSelectStub = _this$props.isSelectStub;

      if (!columns || !columns[0].name) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "table-header"
      }, isSelectStub && _ref, columns.map(this.renderCell));
    }
  }]);
  return TableHeader;
}(_react.PureComponent);

exports.default = TableHeader;
TableHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    fixed: _propTypes.default.bool,
    name: _propTypes.default.func
  }))
} : {};